let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fxE9L")).then(() => parcelRequire('3awtv'));